import { useLegacyCapabilities } from '@apis/rendall/queries/use-capabilities';
import { useSubscriptions } from '@apis/rendall/queries/use-subscriptions';
import { getConfigurationRulesFeatureReleases } from '@features/configuration-rules/release';
import { getDataExplorerFeatureReleases } from '@features/data-explorer/release';
import { getInsightsFeatureReleases } from '@features/insights/release';
import type { FeatureRelease } from '@packages/core/layout/dashboard-app-bar/types';

export const useFeatureReleases = (): FeatureRelease[] => {
  const { data: legacyCapabilities } = useLegacyCapabilities();
  const { data: subscriptions } = useSubscriptions();

  return [
    getDataExplorerFeatureReleases,
    getInsightsFeatureReleases,
    getConfigurationRulesFeatureReleases,
  ]
    .flatMap<FeatureRelease>((featureReleaseGetter) =>
      featureReleaseGetter(subscriptions, legacyCapabilities),
    )
    .filter(
      ({ featureFlag }) => !featureFlag || localStorage.getItem(featureFlag),
    )
    .sort(({ date: dateA }, { date: dateB }) =>
      dateA.isAfter(dateB) ? -1 : 1,
    );
};
